import React from 'react';

export const ExternalLink = (
  linkProps: React.AnchorHTMLAttributes<HTMLAnchorElement>
) => {
  return <a {...{ ...linkProps }}>{linkProps.children}</a>;
};
